/* eslint-disable import/prefer-default-export */
import { useCallback, useState } from "react"
import { Account } from "@mezo/api"
import { PayloadAction } from "@reduxjs/toolkit"

import { loginAccount, useDappDispatch } from "#/redux-state"

import { useResetStateOnDisconnect } from "./helpers"
import { useFetchMats } from "./mats"

export const useLoginAndFetchAccount = () => {
  const [fetchedAccount, setFetchedAccount] = useState<Account | null>(null)

  const { fetchMats } = useFetchMats()
  const dispatch = useDappDispatch()

  useResetStateOnDisconnect<Account | null>(setFetchedAccount, null)

  const loginAndFetchAccountHandler = useCallback(async () => {
    if (fetchedAccount) return fetchedAccount

    const { payload: account } = (await dispatch(
      loginAccount(),
    )) as PayloadAction<Account | null>

    if (account) {
      await fetchMats()
      setFetchedAccount(account)
    }

    return account
  }, [fetchedAccount, dispatch, fetchMats])

  return { loginAndFetchAccount: loginAndFetchAccountHandler }
}
